export const entityLabels = {
	AllowedAreaPointEntity: 'Allowed Area Point',
	BundleEntity: 'Bundle',
	CancellationPoliciesEntity: 'Cancellation Policies',
	CarPoolingSettingEntity: 'Car Pooling Setting',
	CorporateAllowedAreaEntity: 'Corporate Allowed Area',
	CorporateEntity: 'Corporate',
	CorporateRidersEntity: 'Corporate Riders',
	CorporateScheduleEntity: 'Corporate Schedule',
	DriverApprovalSettingEntity: 'Driver Approval Setting',
	DriverDocumentsEntity: 'Driver Documents',
	DriverVehicleDocumentsEntity: 'Driver Vehicle Documents',
	DriverVehicleEntity: 'Driver Vehicle',
	DriverVehicleTypeEntity: 'Driver Vehicle Type',
	FareSurchargeEntity: 'Fare Surcharge',
	FleetOperatorEntity: 'Fleet Operator',
	KmRangeFareEntity: 'KM Range Fare',
	LocationEntity: 'Location',
	LocationWiseFareEntity: 'Location Wise Fare',
	MakeEntity: 'Make',
	ModelEntity: 'Model',
	PurchasedBundleEntity: 'Purchased Bundle',
	RestrictedAreaEntity: 'Restricted Area',
	RiderApprovalSettingEntity: 'Rider Approval Setting',
	SettingEntity: 'Setting',
	UserCorporateEntity: 'User Corporate',
	UserEntity: 'User',
	UserFleetEntity: 'User Fleet',
	VehicleTypeEntity: 'Vehicle Type',
	WayPointEntity: 'Waypoint',
	CorporateDiscountTypeEntity: 'Corporate Discount Type',
	UserTenantEntity: 'User Tenant',
};
export const documentTypeLabels = {
	VEHICLE_TYPE: 'Vehicle Type',
	PROFILE_PICTURE: 'Profile Picture',
	DRIVER_LICENSE_DOCUMENT: 'Driver License',
	BRAND_LOGO: 'Brand Logo',
	FLEET_OPERATOR_DOCUMENT: 'Fleet Operator Document',
	TAG_DOCUMENT: 'Tag Document',
	POLICE_CONDUCT_DOCUMENT: 'Police Conduct Document',
	VEHICLE_INSURANCE_DOCUMENT: 'Vehicle Insurance',
	VEHICLE_LICENSE_PLATE: 'Vehicle License Plate',
	VEHICLE_LICENSE_DISK: 'Vehicle License Disk',
	ID_CARD: 'ID Card',
	DRIVER_ID: 'Driver ID',
};
